import { Panel } from '@components/Panel';
import clsx from 'clsx';
import React from 'react';

interface FormWrapperProps {
  children: React.ReactNode;
}

export const FormWrapper = (props: FormWrapperProps) => {
  return <div className="space-y-4 divide-y divide-gray-200">{props.children}</div>;
};

interface FormSectionProps {
  children: React.ReactNode;
  first?: boolean;
}

export const FormSection = (props: FormSectionProps) => {
  return <div className={clsx('space-y-4', props.first === false && 'pt-8')}>{props.children}</div>;
};

export const FormSectionPanel = (props: FormSectionProps & { panel: boolean }) => {
  if (!props.panel) return <FormSection {...props} />;

  return (
    <Panel>
      <FormSection {...props} />
    </Panel>
  );
};

interface FormHeaderProps {
  title: string;
  description?: string;
  id?: string;
}

export const FormHeader = (props: FormHeaderProps) => {
  return (
    <div id={props.id}>
      <h3 className="text-lg font-medium leading-6 text-gray-900">{props.title}</h3>
      {props.description && <p className="mt-1 text-sm text-gray-500">{props.description}</p>}
    </div>
  );
};
